import React from "react";
import { useNavigate } from "react-router-dom";
import LatestReportBadge from "./LatestReportBadge";
import { EVENT_NAMES, PARAM_KEYS, trackEvent } from "../analytics";
import { getPreferredCategoryPath } from "../utils/locationStorage";
import { useBrand } from "../branding/BrandContext";

export default function Hero({
  personaSrc,
  project,
  setProject,
  projectOptions = [],
}) {
  const navigate = useNavigate();
  const brand = useBrand();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!project) return;

    trackEvent(EVENT_NAMES.CTA_CLICK, {
      [PARAM_KEYS.CTA_NAME]: "hero_get_started",
      [PARAM_KEYS.PLACEMENT]: "home_hero",
      [PARAM_KEYS.CATEGORY_KEY]: project,
    });

    try {
      localStorage.setItem("user_category", project);
    } catch (err) {
      // ignore storage errors
    }

    navigate(getPreferredCategoryPath(project));
  };

  return (
    <section className="hero">
      <div className="heroBg" aria-hidden="true" />

      <div className="container heroInner">
        <div className="heroLeft">
          <div className="personaBlock" aria-hidden="true">
            <img
              className="personaImg"
              src={personaSrc}
              alt=""
              draggable="false"
            />
          </div>
        </div>

        <div className="heroTop">
          <div className="heroTitle">
            <span className="brandEm textShadowSolid">{brand.brandName}</span><sup className="regtrade">TM</sup>
          </div>

          <div className="heroByline textShadowSolid">
            Your spot for fast, fair, and free home upgrade estimates!
          </div>

          <form className="heroForm" onSubmit={handleSubmit}>
            <div className="heroQuestion">
              Kick-off Your Home Project Today!
            </div>
            
            <div className="formRow">
              <div className="selectWrap">
                <select
                  id="project"
                  value={project}
                  onChange={(e) => setProject(e.target.value)}
                >
                  <option value="" disabled>
                    Select project
                  </option>

                  {projectOptions.map((opt) => (
                    <option key={opt.slug} value={opt.slug}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>

              <button className="ctaBtn" type="submit">
                Get Started!
              </button>
            </div>

            <div className="heroFinePrint">
              Free, no-obligation estimates.
            </div>
          </form>

          <div className="heroLatestReportBadgeWrap">
            <LatestReportBadge placement="home_hero" />
          </div>
        </div>

        
        
    </div> 
    <div className="heroBottom" >We use technology to turn photos into fast, fair, no-obligation estimates from trusted local contractors. No pressure, no guesswork — just clear information to help homeowners make confident decisions about their homes.</div>
        
    </section>
  );
}
